import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7e69cee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reference-registry-page" }
const _hoisted_2 = { class: "registry-hero" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Зээлдэгчийн мэдээлэл")
const _hoisted_5 = { class: "registry-kicker" }
const _hoisted_6 = { class: "registry-hero-stats" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "нийт мөр", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "хуудсанд", -1))
const _hoisted_9 = { class: "registry-toolbar" }
const _hoisted_10 = { class: "registry-search" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Хайх ")
const _hoisted_12 = { class: "registry-actions" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Зээл ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Зээлийн шугам ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Шинэчлэх ")
const _hoisted_16 = { class: "registry-table-shell" }
const _hoisted_17 = ["disabled", "onClick"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "registry-pagination" }
const _hoisted_21 = {
  key: 1,
  class: "registry-empty-state"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Хандах эрхгүй", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Энэ лавлагаанд зөвхөн Монголбанкны хэрэглэгч болон тохирох эрхтэй хэрэглэгч хандана. ", -1))
const _hoisted_25 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_el_breadcrumb, {
          "separator-class": "el-icon-arrow-right",
          class: "registry-breadcrumb"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.config.title), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.config.kicker), 1),
        _createElementVNode("h1", null, _toDisplayString(_ctx.config.title), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.config.description), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.formatNumber(_ctx.total)), 1),
          _hoisted_7
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.formatNumber(_ctx.pageSize)), 1),
          _hoisted_8
        ])
      ])
    ]),
    (_ctx.canAccess)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                "prefix-icon": "el-icon-search",
                clearable: "",
                size: "mini",
                placeholder: "Нэр, регистр, дугаар, гэрээгээр хайх...",
                onKeyup: _withKeys(_ctx.submitSearch, ["enter"]),
                onClear: _ctx.submitSearch
              }, null, 8, ["modelValue", "onKeyup", "onClear"]),
              _createVNode(_component_el_button, {
                type: "primary",
                icon: "el-icon-search",
                size: "mini",
                loading: _ctx.loading,
                onClick: _ctx.submitSearch
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.config.kind === 'customers')
                ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 0,
                    modelValue: _ctx.customerType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customerType) = $event)),
                    size: "mini",
                    class: "customer-type-select",
                    placeholder: "Төрөл",
                    onChange: _ctx.handleCustomerTypeChange
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: "",
                        label: "Бүх төрөл"
                      }),
                      _createVNode(_component_el_option, {
                        value: "citizen",
                        label: "Иргэн"
                      }),
                      _createVNode(_component_el_option, {
                        value: "foreignCitizen",
                        label: "Гадаад иргэн"
                      }),
                      _createVNode(_component_el_option, {
                        value: "organization",
                        label: "Хуулийн этгээд"
                      }),
                      _createVNode(_component_el_option, {
                        value: "foreignOrganization",
                        label: "Гадаад хуулийн этгээд"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"]))
                : _createCommentVNode("", true),
              (_ctx.config.kind === 'collaterals')
                ? (_openBlock(), _createBlock(_component_el_radio_group, {
                    key: 1,
                    modelValue: _ctx.collateralType,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collateralType) = $event)),
                    size: "mini",
                    onChange: _ctx.handleCollateralTypeChange
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_button, {
                        label: "loan",
                        disabled: !_ctx.$hasAnyRole('T_COLLATERAL', 'T_COLLATERAL_OWNERS')
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_el_radio_button, {
                        label: "loanline",
                        disabled: 
                !_ctx.$hasAnyRole('T_COLLATERAL_LINE', 'T_COLLATERAL_LINE_OWNERS')
              
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_select, {
                modelValue: _ctx.pageSize,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pageSize) = $event)),
                size: "mini",
                class: "page-size-select",
                onChange: _ctx.handleSizeChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    value: 10,
                    label: "10 мөр"
                  }),
                  _createVNode(_component_el_option, {
                    value: 20,
                    label: "20 мөр"
                  }),
                  _createVNode(_component_el_option, {
                    value: 50,
                    label: "50 мөр"
                  }),
                  _createVNode(_component_el_option, {
                    value: 100,
                    label: "100 мөр"
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"]),
              _createVNode(_component_el_button, {
                icon: "el-icon-refresh",
                size: "mini",
                loading: _ctx.loading,
                onClick: _ctx.fetchRows
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _ctx.rows,
              border: "",
              stripe: "",
              size: "mini",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл олдсонгүй.",
              class: "registry-table",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "Д/д",
                  type: "index",
                  index: _ctx.indexMethod,
                  width: "64"
                }, null, 8, ["index"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleColumns, (column) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    key: column.prop,
                    prop: column.prop,
                    label: column.label,
                    "min-width": column.width || 140,
                    "show-overflow-tooltip": ""
                  }, {
                    default: _withCtx((scope) => [
                      (column.link)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "registry-link",
                            disabled: !_ctx.getLoanNavigation(scope.row),
                            onClick: ($event: any) => (_ctx.openLoanDetails(scope.row))
                          }, _toDisplayString(scope.row[column.prop] || "-"), 9, _hoisted_17))
                        : (column.money)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.formatMoney(scope.row[column.prop])), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(scope.row[column.prop] || "-"), 1))
                    ]),
                    _: 2
                  }, 1032, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(_ctx.total)) + " мөрөөс " + _toDisplayString(_ctx.currentRange), 1),
              _createVNode(_component_el_pagination, {
                background: "",
                layout: "prev, pager, next, jumper",
                "current-page": _ctx.page,
                "page-size": _ctx.pageSize,
                total: _ctx.total,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"])
            ])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_25))
  ]))
}